const withAdClickedEvent = () => () => ({
  schema: 'iglu:au.com.realestate/media_ads_clicked/jsonschema/1-0-0',
  data: {
    event_name: 'media_ads_clicked',
  },
});

export default withAdClickedEvent;
